export function formatShortAddress(address: string | null) {
  if (!address) return ''
  const hex = address.split('x')[1]
  const firstFour = hex.slice(0, 4).toLowerCase()
  const lastFour = hex.slice(-4).toLowerCase()
  return `0×${firstFour}…${lastFour}`
}
